// The landing page: a signed-in owner or manager goes straight to the dashboard (or to the setup when they have no
// venue yet); anyone else gets the sign-in button. Staff screens and boards open from the dashboard's links.
import { useEffect } from 'react';
import { UI, type Lang } from '@ringring/core';
import { api, type Me } from './api';
import { AuthLayout } from './AuthLayout';
import { Icon } from './Icon';

export function Home({ lang, setLang }: { lang: Lang; setLang: (l: Lang) => void }) {
  const t = UI[lang];
  useEffect(() => {
    api<Me>('/auth/me')
      .then((me) => {
        window.location.hash = me.venues.length > 0 ? '#/dashboard' : '#/setup';
      })
      .catch(() => {
        // not signed in: stay here
      });
  }, []);
  return (
    <AuthLayout lang={lang} setLang={setLang}>
      <p className="eyebrow auth-eyebrow">{t.design_restaurant_space}</p>
      <div className="card signin home-intro">
        <h1 className="display">{t.design_service_heading}</h1>
        <p className="muted">{t.home_tagline}</p>
        <a className="btn" href="#/signin">
          {t.sign_in}
          <Icon name="arrow" className="directional" />
        </a>
        <p className="muted">{t.signin_intro}</p>
      </div>
    </AuthLayout>
  );
}
